import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MeetingService} from '../../services/meeting.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {ToasterService} from 'angular2-toaster';

import {CookieService} from 'angular2-cookie/services/cookies.service';

import * as moment from 'moment';

declare var $: any;
declare var document: any;

interface TimeDisplay {
  value: string;
  display: string;
}

@Component({
  selector: 'app-page1', templateUrl: './page1.component.html', styleUrls: ['./page1.component.css']
})
export class Page1Component implements OnInit, OnDestroy {
  // @ViewChild('mycal', { read: ElementRef }) myCal: ElementRef;
  // connected: Subscription;

  busy: Promise<any>;
  calOptions: any = {};
  click_date: any;
  e_name: any;
  f_time: any;
  t_time: any;
  date_val: any;
  authcode: any;
  city: any = [];
  buildings: any = [];
  rooms: any = [];
  select_city: any;
  select_building: any;
  select_room: any;
  calenderview: any = 'month';
  avail_hours: any = '';
  room_id: any;
  msg: any;
  s_msg: any;
  user: any = [];
  seats: any;
  skipdate: any;
  date_eve: any;
  current: any;
  interval: any;
  building_id: any;
  currentDate: any = [];
  missinghours: any;
  cs_msg: any;
  err_msg: any;
  payment_fail: any;
  saved_cards: any = [];
  hourDiff: any;
  city_id: any;
  def_city: any = '0';
  neutral_event2: any = [];
  today = new Date();
  defaultCityModalCloseable = false;
  // cvv: any;
  openTimeIntervalArray: TimeDisplay[] = [];
  private sub: any;

  def_f = '';
  def_t = '';

  constructor(public router: Router, public meetingService: MeetingService, private _cookieService: CookieService, private storage: LocalStorageService, private toasterService: ToasterService) {

    const val = this.storage.get('user');
    // console.log(val);
    if (val) {
      // console.log(val);
      this.user = val;
      this.avail_hours = val[0].hours;
      this.authcode = val[0].authcode;
      if (this.storage.get('neutral_event')) {
        const ntrl_evnt = this.storage.get('neutral_event');
        this.def_t= ntrl_evnt[0].t_time
        this.def_f= ntrl_evnt[0].f_time
        console.log('HERE');
        console.log(this.def_f);

        // // console.log(ntrl_evnt[0].f_time);
        this.e_name = ntrl_evnt[0].e_name;
        $(document).ready(function () {
          // $('f_time2').val(ntrl_evnt[0].f_time);
          // $('#t_time2').val(ntrl_evnt[0].t_time);

          function cleanUpHour(str) {
            var spli_t = str.split(':');
            if (parseInt(spli_t[0]) < 12) {
              return spli_t[0] + ':' + spli_t[1] + 'am';
            }
            const r = (parseInt(spli_t[0]) - 12);
            return r + ':' + spli_t[1] + 'pm';
          }


          $('.f_time2').val(ntrl_evnt[0].f_time).change();
          $('.t_time2').val(ntrl_evnt[0].t_time).change();


          $('#rumid2').val(ntrl_evnt[0].r_id);
          $('#ntrlcity_id').val(ntrl_evnt[0].city_id);
          $('#ntrl_address').val(ntrl_evnt[0].address);
          $('#ntrl_building_id').val(ntrl_evnt[0].building_id);
          $('#click_date2').val(ntrl_evnt[0].click_date);
          // $('#f_time').val(ntrl_evnt[0].f_time);
          // $('#t_time').val(ntrl_evnt[0].t_time);

          $('.f_time').val(ntrl_evnt[0].f_time);
          $('.t_time').val(ntrl_evnt[0].t_time);

          $('#rumid').val(ntrl_evnt[0].r_id);
          $('#click_date').val(ntrl_evnt[0].click_date);
          // $('#ntrl_name').append(ntrl_evnt[0].e_name);
          // $('#ntrl_ft').append(ntrl_evnt[0].f_time);
          // $('#ntrl_tt').append(ntrl_evnt[0].t_time);
          $('#select_room1 b').empty();
          $('#select_room1 b').append(ntrl_evnt[0].room_name);
          const cdate = moment(new Date(ntrl_evnt[0].click_date)).format('MM/DD/YYYY');
          // const cdate = datePipe.transform(new Date(ntrl_evnt[0].click_date), 'MM/dd/yyyy');
          $('#ntrl_eve_msg').html(`
            Your meeting request <span style="font-weight:bold" id="ntrl_name">
            ${ntrl_evnt[0].e_name}
            </span> for <span style="font-weight:bold" id="ntrl_cd">
            ${cdate}
            </span> from <span style="font-weight:bold" id="ntrl_ft">
            ${cleanUpHour(ntrl_evnt[0].f_time)}
            </span> to <span style="font-weight:bold" id="ntrl_tt">
            ${cleanUpHour(ntrl_evnt[0].t_time)}
            </span> is pending. Click Book to proceed or click Cancel.`);
          // $('#ntrl_cd').append(datePipe.transform(new Date(ntrl_evnt[0].click_date), 'MM/dd/yyyy'));
          $('#neutral_event').modal('show');
        });
        this.storage.remove('neutral_event');
      }
      this.getCity();
    } else {
      // // console.log("page1 else");
      const link = ['/login'];
      this.router.navigate(link);
    }
    this.cs_msg = this._cookieService.get('card_save');
    this.err_msg = this._cookieService.get('wrong');
    // // console.log(this.u_msg);
    window.scrollTo(0, 0);
    this.interval = setTimeout(() => {
      this._cookieService.remove('card_save');
      this._cookieService.remove('wrong');
      this.cs_msg = '';
      this.payment_fail = '';
      this.err_msg = '';
      // $(".alert").fadeTo(2000, 500).slideUp(500, function(){
      //   //  $(".alert").slideUp(500);
      // });
    }, 3000);
    // var hdrtitle = "boca raton";
    // this.calOptions ={
    const cst = this;
    $(document).ready(function () {

      $('#calendar').fullCalendar({
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        droppable: true,
        selectable: true,
        header: {
          left: 'title', // center: '',
          right: 'agendaWeek,agendaDay prev,next'
        },
        fixedWeekCount: false,
        defaultDate: new Date(),
        editable: true,
        defaultView: 'agendaDay',
        views: {
          Buildingweek: {
            type: 'agendaWeek', groupByDateAndResource: true,
          }, agendaDay: {
            groupByDateAndResource: false,
          }, Buildingday: {
            type: 'agendaDay', groupByDateAndResource: true,
          }
        },
        viewRender: function (view, element) {
          // console.log('new view: ' + view.name);
          if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {

            if (storage.get('select_room_id')) {
              $('#calendar').fullCalendar('changeView', 'agendaWeek');
            } else if (storage.get('select_building_id')) {
              if (cst.rooms) {
                for (let i = 0; i < cst.rooms.length; i++) {
                  $('th[data-resource-id=' + cst.rooms[i].id + ']')
                    .html('<b>' + cst.rooms[i].caldesc + '</b><p style=\'font-weight:100\'>' + cst.rooms[i].line2 + '</p>');
                }
              }
              $('#calendar').fullCalendar('changeView', 'Buildingweek');
            } else {
              $('#calendar').fullCalendar('changeView', 'agendaWeek');
            }
          } else if (view.name === 'agendaDay' || view.name === 'Buildingday') {

            if (storage.get('select_room_id')) {
              //  $(".fc-agendaDay-button").click();
              $('#calendar').fullCalendar('changeView', 'agendaDay');
            } else if (storage.get('select_building_id')) {
              if (cst.rooms) {
                for (let i = 0; i < cst.rooms.length; i++) {
                  $('th[data-resource-id=' + cst.rooms[i].id + ']')
                    .html('<b>' + cst.rooms[i].caldesc + '</b><p style=\'font-weight:100\'>' + cst.rooms[i].line2 + '</p>');
                }
              }
              $('#calendar').fullCalendar('changeView', 'Buildingday');
            } else {
              $('#calendar').fullCalendar('changeView', 'agendaDay');
            }
          }
        },
        weekends: false,
        hiddenDays: [6, 7],
        minTime: '08:30:00',
        maxTime: '18:30:00',
        height: 'auto',
        resources: [],
        eventLimit: true,
        events: [],
        timezone: 'local',
        allDaySlot: false,
        longPressDelay: true,
        select: function (start, end, jsEvent, view, resource) {

          if (resource) {
            // console.log(resource.temp_name);
            $('#select_room b').empty();
            $('#select_room b').append('Room: ' + resource.temp_name);
            const resourceId = resource.id;
            $('#rumid').val(resourceId);
          }
          // // console.log(end);
          $('#click_date').val(start._d);
          (<any>$('#myModal33')).modal('show');
          let d = start._i[3].toString();
          let c = start._i[4].toString();
          let d1 = end._i[3].toString();
          let c1 = end._i[4].toString();
          if (d.length === 1) {
            d = '0' + d;
          }
          if (c.length === 1) {
            c = '0' + c;
          }
          if (d1.length === 1) {
            d1 = '0' + d1;
          }
          if (c1.length === 1) {
            c1 = '0' + c1;
          }
          const time = d + ':' + c;
          const time1 = d1 + ':' + c1;
          // // console.log(time);
          // // console.log(time1);
          $('#curdate').empty();
          $('#curdate').append(moment(new Date(start._d)).format('DD-MMM-YYYY'));
          // $('#curdate').append(datePipe.transform(new Date(start._d), 'dd-MMM-yyyy'));
          $('.f_time').val(time);
          $('.t_time').val(time1);
          // $('#f_time').val(time);
          // $('#t_time').val(time1);
          $('#delbtn').hide();
          $('#addbtn').show();
          $('#updatebtn').hide();
          $('#buyxxhour').hide();
          $('#buy5hour').hide();
          $('#buy15hour').hide();
          $('.never_expire').empty();
          $('.not_enough_hour').empty();
        },
        eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
          const millisec = delta._milliseconds;
          const hours = (millisec / (1000 * 60 * 60)).toFixed(1);
          // $( "#cancel_changes" ).click(function() {
          //   revertFunc();
          // });
          if (event.avail_hours < hours) {
            revertFunc();
            window.scrollTo(0, 0);
            $('.revertalert').empty();
            $('.revertalert').append(`
                <div class="alert alert-warning alert-dismissable revertalert">
                  <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                  Not Enough Hours.
                </div>`);
            setTimeout(function () {
              $('.alert').fadeTo(2000, 500).slideUp(500, function () {
                $('.alert').slideUp(500);
              });
            }, 30000);
          } else {
            (<any>$('#myModal33')).modal('show');
            let d = event.start._i[3].toString();
            let c = event.start._i[4].toString();
            let d1 = event.end._i[3].toString();
            let c1 = event.end._i[4].toString();
            if (d.length === 1) {
              d = '0' + d;
            }
            if (c.length === 1) {
              c = '0' + c;
            }
            if (d1.length === 1) {
              d1 = '0' + d1;
            }
            if (c1.length === 1) {
              c1 = '0' + c1;
            }
            const out = d + ':' + c;
            const out1 = d1 + ':' + c1;
            // // console.log(event.title);
            $('#e_name').val(event.title);
            // $('#f_time').val(out);
            // $('#t_time').val(out1);
            $('.f_time').val(out);
            $('.t_time').val(out1);
            $('#delete_click').val(event.id);
            $('#event_date').val(event.start._d);
            $('#curdate').empty();
            $('#curdate').append(moment(new Date(event.start._d)).format('DD-MMM-YYYY'));
            // $('#curdate').append(datePipe.transform(new Date(event.start._d), 'dd-MMM-yyyy'));
            $('#delbtn').hide();
            $('#addbtn').hide();
            $('#updatebtn').show();
            $('#buyxxhour').hide();
            $('#buy5hour').hide();
            $('#buy15hour').hide();
            $('.never_expire').empty();
            $('.not_enough_hour').empty();
          }
          // }
        },
        eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
          // if(event.editable != 0){
          // $( "#cancel_changes" ).click(function() {
          //   revertFunc();
          // });
          (<any>$('#myModal33')).modal('show');
          // // console.log(date);
          // // console.log(event);
          let d = event.start._i[3].toString();
          let c = event.start._i[4].toString();
          let d1 = event.end._i[3].toString();
          let c1 = event.end._i[4].toString();
          if (d.length === 1) {
            d = '0' + d;
          }
          if (c.length === 1) {
            c = '0' + c;
          }
          if (d1.length === 1) {
            d1 = '0' + d1;
          }
          if (c1.length === 1) {
            c1 = '0' + c1;
          }
          const out = d + ':' + c;
          const out1 = d1 + ':' + c1;
          // // console.log(out);
          // // console.log(out1);
          // // console.log(event.title);
          $('#e_name').val(event.title);
          $('.f_time').val(out);
          $('.t_time').val(out1);
          // $('#f_time').val(out);
          // $('#t_time').val(out1);
          $('#delete_click').val(event.id);
          $('#event_date').val(event.start._d);
          $('#curdate').empty();
          $('#curdate').append(moment(new Date(event.start._d)).format('DD-MMM-YYYY'));
          // $('#curdate').append(datePipe.transform(new Date(event.start._d), 'dd-MMM-yyyy'));
          $('#delbtn').hide();
          $('#addbtn').hide();
          $('#updatebtn').show();
          $('#buyxxhour').hide();
          $('#buy5hour').hide();
          $('#buy15hour').hide();
          $('.never_expire').empty();
          $('.not_enough_hour').empty();
          // }
        },
        eventClick: function (event, jsEvent, view) {
          // // console.log(event);
          if (event.editable !== false) {
            (<any>$('#myModal33')).modal('show');

            if (event.start._f) {
              const a = event.start._i;
              const a1 = event.end._i;
              const position = 11;
              $('#e_name').val(event.title);
              const output = a.slice(position);
              const output1 = a1.slice(position);
              const out: string = output.substring(0, 5);
              const out1: string = output1.substring(0, 5);
              // $('#f_time').val(out);
              $('.f_time').val(out);
              this.f_time = out;
              // $('#t_time').val(out1);
              $('.t_time').val(out1);
              this.t_time = out1;
            } else {
              let d = event.start._i[3].toString();
              let c = event.start._i[4].toString();
              let d1 = event.end._i[3].toString();
              let c1 = event.end._i[4].toString();
              if (d.length === 1) {
                d = '0' + d;
              }
              if (c.length === 1) {
                c = '0' + c;
              }
              if (d1.length === 1) {
                d1 = '0' + d1;
              }
              if (c1.length === 1) {
                c1 = '0' + c1;
              }
              const out = d + ':' + c;
              const out1 = d1 + ':' + c1;
              this.f_time = out;
              // $('#f_time').val(out);
              $('.f_time').val(out);
              this.t_time = out1;
              // $('#t_time').val(out1);
              $('.t_time').val(out1);
            }
            $('#resourceID').val(event.resourceId);
            $('#delete_click').val(event.id);
            $('#event_date').val(event.start._d);
            $('#curdate').empty();
            $('#curdate').append(moment(new Date(event.start._d)).format('DD-MMM-YYYY'));
            // $('#curdate').append(datePipe.transform(new Date(event.start._d), 'dd-MMM-yyyy'));
            $('#delbtn').show();
            $('#updatebtn').show();
            $('#addbtn').hide();
            $('#buyxxhour').hide();
            $('#buy5hour').hide();
            $('#buy15hour').hide();
            $('.never_expire').empty();
            $('.not_enough_hour').empty();
          }
        },
        dayClick: function (date, jsEvent, view) {

          // console.log(date);
          let d = date._i[3].toString();
          let c = date._i[4].toString();
          if (d.length === 1) {
            d = '0' + d;
          }
          if (c.length === 1) {
            c = '0' + c;
          }
          const time = d + ':' + c;
          $('#e_name').val('');
          $('.f_time').val(time);
          $('.t_time').val('');
          // $('#f_time').val(time);
          // $('#t_time').val('');
          (<any>$('#myModal33')).modal('show');
          $('#curdate').empty();
          $('#curdate').append(moment(new Date(date._d)).format('DD-MMM-YYYY'));
          // $('#curdate').append(datePipe.transform(new Date(date._d), 'dd-MMM-yyyy'));
          $('#click_date').val(date._d);
          $('#delbtn').hide();
          $('#updatebtn').hide();
          $('#addbtn').show();
          $('#buyxxhour').hide();
          $('#buy5hour').hide();
          $('#buy15hour').hide();
          $('.never_expire').empty();
          $('.not_enough_hour').empty();
        }
      });
      // alert("hii");
      $('.fc-agendaWeek-button').html('week view');
      $('.fc-agendaDay-button').html('day view');

    });

    const self = this;
    $(function () {
      $('body').on('click', 'button.fc-prev-button', function () {
        self.fetchBuildingMeeting();
      });

      $('body').on('click', 'button.fc-next-button', function () {
        self.fetchBuildingMeeting();
      });

      $('body').on('click', 'button.fc-agendaWeek-button', function () {
        self.fetchBuildingMeeting();
      });
    });

    // $('#myModal33').
    $(document).ready(function () {
      $('#myModal33').on('shown.bs.modal', function () {
        const val2 = $('#resourceID').val();
        if (val2) {
          for (let i = 0; i < self.rooms.length; i++) {
            if (self.rooms[i].id === val2) {
              $('#select_room b').empty();
              $('#select_room b').append('Room: ' + self.rooms[i].roomname);
              $('#resourceID').val('');
            }
          }
        }
      });
    });

    // }
  }

  populateOpenTimeIntervalArray(p_startTime, p_endTIme) {
    const startTimeMoment = moment('2013-02-08 ' + p_startTime);
    const unixEndTime = moment('2013-02-08 ' + p_endTIme);

    let startTime = startTimeMoment.unix() * 1000;
    const endTIme = unixEndTime.unix() * 1000;

    const timeIntervals = [startTime];
    while (startTime < endTIme) {
      startTime += 30 * 60000;
      timeIntervals.push(startTime);
    }
    // timeIntervals = timeIntervals.map( t => (new Date(t)).toTimeString().replace(/\s[\w\s\+\(\)]+/i, '').replace(/:\d+$/, ''));
    this.openTimeIntervalArray = timeIntervals.map(t => {
      /*let h = (this.convertDateForIos(t)).getHours() + '';
      h = h.length < 2 ? `0${h}` : h;
      let m = (this.convertDateForIos(t)).getMinutes() + '';
      m = m.length < 2 ? `0${m}` : m;*/
      return {
        value: moment.unix(t / 1000).format('HH:mm'), display: moment.unix(t / 1000).format('hh:mm a')
      }; // `${h}:${m}`;
    });
  }

  ngOnInit(): void {
    // this.sub = this.activatedRoute.queryParams.subscribe(params => {
    //    // console.log(params);
    // });
    // this.sub.detectChanges();
    // var qryparam = this.activatedRoute.snapshot.queryParamMap;
    // if(qryparam){
    //   // console.log(qryparam['params']);
    //   if(qryparam['params'].m_id){
    //     // this.meetingFromProfile(qryparam['params']);
    //   }
    // }

    this.interval = setInterval(() => {
      if (this.room_id) {
        this.fetchRoommeeting(this.room_id);
      } else {
        if (this.building_id) {
          this.currentDate = $('#calendar').fullCalendar('getDate');
          const cur_view = $('#calendar').fullCalendar('getView');
          const dt = new Date(this.currentDate._d);

          const dayname = moment(dt).format('ddd');
          // const dayname = this.datePipe.transform(dt, 'EE');

          let ldt;
          let stdt;

          // console.log(dt);
          if (cur_view.name === 'agendaWeek' || cur_view.name === 'Buildingweek') {
            if (dayname === 'Mon') {
              const chk = dt.setDate(dt.getDate());
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // stdt = this.datePipe.transform(st, 'yyyy-MM-dd');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 4);
            } else if (dayname === 'Tue') {
              const chk = dt.setDate(dt.getDate() - 1);
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 4);
            } else if (dayname === 'Wed') {
              const chk = dt.setDate(dt.getDate() - 2);
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 4);
            } else if (dayname === 'Thu') {
              const chk = dt.setDate(dt.getDate() - 3);
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 4);
            } else if (dayname === 'Fri') {
              const chk = dt.setDate(dt.getDate() - 4);
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 4);
            } else if (dayname === 'Sat') {
              const chk = dt.setDate(dt.getDate() - 5);
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 4);
            } else if (dayname === 'Sun') {
              // console.log("hiii");
              const chk = dt.setDate(dt.getDate() + 1);
              const st = new Date(chk);
              stdt = moment(st).format('YYYY-MM-DD');
              // console.log(stdt);
              ldt = dt.setDate(dt.getDate() + 5);
            }

          } else {
            stdt = moment(dt).format('YYYY-MM-DD');
            ldt = dt.setDate(dt.getDate() + 1);
          }
          const ldtd = new Date(ldt);
          const ltdt = moment(ldtd).format('YYYY-MM-DD');
          // const ltdt = this.datePipe.transform(ldtd, 'yyyy-MM-dd');

          this.meetingService.getBuildingsMeeting(this.building_id, this.authcode, stdt, ltdt).subscribe(response => {
            if (response) {
              if (+response.success === -1) {
                this.logOut(response.message);
              } else {

                $('#calendar').fullCalendar('removeEvents');

                if (cur_view.name === 'agendaWeek' || cur_view.name === 'Buildingweek') {
                  $('#calendar').fullCalendar('changeView', 'Buildingweek');
                } else {
                  $('#calendar').fullCalendar('changeView', 'Buildingday');
                }
                for (let i = 0; i < response.length; i++) {
                  // if(response[i].userid == this.user[0].userid){

                  let editable;
                  let color;

                  if (+response[i].editable === 0) {
                    editable = false;
                    color = '#3a87ad';
                  } else {
                    editable = true;
                    color = '#8dc009';
                  }
                  const event = {
                    id: response[i].meetingid,
                    resourceId: response[i].roomid,
                    title: response[i].description,
                    start: response[i].start,
                    end: response[i].end,
                    editable: editable,
                    color: color,
                    avail_hours: this.avail_hours
                  };
                  $('#calendar').fullCalendar('renderEvent', event, true);
                  // }
                }
              }
            } else {
              // console.log("error");
            }
          });
        }
      }
    }, 60000);

  }

  // getCookie(){
  //   var name = "user=";
  //   var decodedCookie = decodeURIComponent(document.cookie);
  //   var ca = decodedCookie.split(';');
  //   for(var i = 0; i <ca.length; i++) {
  //       var c = ca[i];
  //       while (c.charAt(0) == ' ') {
  //           c = c.substring(1);
  //       }
  //       if (c.indexOf(name) == 0) {
  //         var data;
  //           return data = JSON.parse(c.substring(name.length, c.length));
  //
  //       }
  //   }
  //   return '';
  // }

  fetchRoommeeting(r_id) {
    this.currentDate = $('#calendar').fullCalendar('getDate');
    const view = $('#calendar').fullCalendar('getView');
    if (view.name === 'Buildingweek') {
      $('#calendar').fullCalendar('changeView', 'agendaWeek');
    } else if (view.name === 'agendaDay') {
      $('#calendar').fullCalendar('changeView', 'agendaDay');
    }
    const dt = new Date(this.currentDate._d);
    // const dayname = this.datePipe.transform(dt, 'EE');
    const dayname = moment(dt).format('ddd');

    // console.log(dt);

    let stdt;
    let ldt;

    if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
      if (dayname === 'Mon') {
        const chk = dt.setDate(dt.getDate());
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Tue') {
        const chk = dt.setDate(dt.getDate() - 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Wed') {
        const chk = dt.setDate(dt.getDate() - 2);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Thu') {
        const chk = dt.setDate(dt.getDate() - 3);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Fri') {
        const chk = dt.setDate(dt.getDate() - 4);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sat') {
        const chk = dt.setDate(dt.getDate() - 5);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sun') {
        // console.log("hiii");
        const chk = dt.setDate(dt.getDate() + 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 5);
      }

    } else {
      stdt = moment(dt).format('YYYY-MM-DD'); // this.datePipe.transform(dt, 'yyyy-MM-dd');
      ldt = dt.setDate(dt.getDate() + 1);
    }
    const ldtd = new Date(ldt);
    const ltdt = moment(ldtd).format('YYYY-MM-DD'); // this.datePipe.transform(ldtd, 'yyyy-MM-dd');
    this.meetingService.getRoomsMeeting(r_id, this.authcode, stdt, ltdt).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          $('#calendar').fullCalendar('removeEvents');
          for (let i = 0; i < response.length; i++) {
            // if(response[i].userid == this.user[0].userid){

            let editable;
            let color;

            if (+response[i].editable === 0) {
              editable = false;
              color = '#3a87ad';
            } else {
              editable = true;
              color = '#8dc009';
            }
            const event = {
              id: response[i].meetingid,
              resourceId: response[i].roomid,
              title: response[i].description,
              start: response[i].start,
              end: response[i].end,
              editable: editable,
              color: color,
              avail_hours: this.avail_hours
            };
            $('#calendar').fullCalendar('renderEvent', event, true);
            // }
          }
        }
      }
    });
  }

  fetchBuildingMeeting() {
    if (this.room_id) {
      // console.log("in room");
      $('#calendar').fullCalendar('removeEvents');
      this.getRoomsMeeting(this.room_id);
      this.building_id = null;
      // return false;
    } else if (this.building_id) {
      // console.log("in building");
      $('#calendar').fullCalendar('removeEvents');
      this.getBuildingsMeetingbyside(this.building_id, this.authcode);
    }
  }


  getBuildingsMeetingbyside(b_id, authcode) {
    this.building_id = b_id;
    $('#calendar').fullCalendar('removeEvents');
    this.currentDate = $('#calendar').fullCalendar('getDate');
    const view = $('#calendar').fullCalendar('getView');
    // // console.log(this.currentDate);
    const dt = new Date(this.currentDate._d);
    const dayname = moment(dt).format('ddd'); // this.datePipe.transform(dt, 'EE');
    // console.log(dt);
    // var stdt = this.datePipe.transform(dt, 'yyyy-MM-dd');

    let ldt;
    let stdt;

    if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
      if (dayname === 'Mon') {
        const chk = dt.setDate(dt.getDate());
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Tue') {
        const chk = dt.setDate(dt.getDate() - 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Wed') {
        const chk = dt.setDate(dt.getDate() - 2);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Thu') {
        const chk = dt.setDate(dt.getDate() - 3);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Fri') {
        const chk = dt.setDate(dt.getDate() - 4);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sat') {
        const chk = dt.setDate(dt.getDate() - 5);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sun') {
        // console.log("hiii");
        const chk = dt.setDate(dt.getDate() + 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 5);
      }

    } else {
      stdt = moment(dt).format('YYYY-MM-DD'); // this.datePipe.transform(dt, 'yyyy-MM-dd');
      ldt = dt.setDate(dt.getDate() + 1);
    }
    const ldtd = new Date(ldt);
    const ltdt = moment(ldtd).format('YYYY-MM-DD'); // this.datePipe.transform(ldtd, 'yyyy-MM-dd');

    // this.subscription.add(
    this.meetingService.getBuildingsMeeting(b_id, authcode, stdt, ltdt).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {

          $('#calendar').fullCalendar('removeEvents');
          for (let i = 0; i < response.length; i++) {
            // if(response[i].userid == this.user[0].userid){

            let color;
            let editable;

            if (+response[i].editable === 0 ) {
              editable = false;
              color = '#3a87ad';
            } else {
              editable = true;
              color = '#8dc009';
            }
            const event = {
              id: response[i].meetingid,
              resourceId: response[i].roomid,
              title: response[i].description,
              start: response[i].start,
              end: response[i].end,
              editable: editable,
              color: color,
              avail_hours: this.avail_hours
            };
            $('#calendar').fullCalendar('renderEvent', event, true);
            // }
          }
        }
      }
    });
  }


  getAllMeetings() {
    this.busy = this.meetingService.getAllMeetings(this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          // console.log(response);
          $('#calendar').fullCalendar('refetchEvents');
          $('#calendar').fullCalendar('removeEvents');
          for (let i = 0; i < response.length; i++) {

            let editable;
            let color;

            if (+response[i].editable === 0) {
              editable = false;
              color = '#3a87ad';
            } else {
              editable = true;
              color = '#8dc009';
            }
            const event = {
              id: response[i].meetingid,
              resourceId: response[i].roomid,
              title: response[i].description,
              start: response[i].start,
              end: response[i].end,
              editable: editable,
              color: color,
              avail_hours: this.avail_hours
            };
            $('#calendar').fullCalendar('renderEvent', event, true);
          }
          this.getavailHours();
        }
      }
    });
  }

  getavailHours() {
    this.meetingService.getavailHours(this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          this.avail_hours = response.hours;
          this.user[0].hours = this.avail_hours;
          this.storage.set('user', this.user);
          // // console.log(this.storage.get('user'));
          if (this.storage.get('neutral_event2')) {
            const ntrl_eve2 = this.storage.get('neutral_event2');
            if (ntrl_eve2[0].past_avail_hour < this.avail_hours) {
              const dis = this;
              this.e_name = ntrl_eve2[0].e_name;
              $(document).ready(function () {


                function cleanUpHour(str) {
                  var spli_t = str.split(':');
                  if (parseInt(spli_t[0]) < 12) {
                    return spli_t[0] + ':' + spli_t[1] + 'am';
                  }
                  const r = (parseInt(spli_t[0]) - 12);
                  return r + ':' + spli_t[1] + 'pm';
                }

                // $('#f_time2').val(ntrl_eve2[0].f_time);
                // $('#t_time2').val(ntrl_eve2[0].t_time);
                $('.f_time2').val(ntrl_eve2[0].f_time);
                $('.t_time2').val(ntrl_eve2[0].t_time);
                $('#rumid2').val(ntrl_eve2[0].r_id);
                $('#ntrlcity_id').val(ntrl_eve2[0].city_id);
                $('#ntrl_address').val(ntrl_eve2[0].address);
                $('#ntrl_building_id').val(ntrl_eve2[0].building_id);
                $('#click_date2').val(ntrl_eve2[0].click_date);
                $('.f_time').val(ntrl_eve2[0].f_time);
                $('.t_time').val(ntrl_eve2[0].t_time);
                // $('#f_time').val(ntrl_eve2[0].f_time);
                // $('#t_time').val(ntrl_eve2[0].t_time);
                $('#rumid').val(ntrl_eve2[0].r_id);
                $('#click_date').val(ntrl_eve2[0].click_date);
                // $('#ntrl_name').append(ntrl_evnt[0].e_name);
                // $('#ntrl_ft').append(ntrl_evnt[0].f_time);
                // $('#ntrl_tt').append(ntrl_evnt[0].t_time);
                $('#select_room1 b').empty();
                $('#select_room1 b').append(ntrl_eve2[0].room_name);
                const cdate = moment(new Date(ntrl_eve2[0].click_date)).format('MM/DD/YYYY');
                // dis.datePipe.transform(new Date(ntrl_eve2[0].click_date), 'MM/dd/yyyy');
                $('#ntrl_eve_msg').html(`
                Your meeting request <span style="font-weight:bold" id="ntrl_name">${ntrl_eve2[0].e_name}</span>
                  for <span style="font-weight:bold" id="ntrl_cd">${cdate}</span> from
                  <span style="font-weight:bold" id="ntrl_ft">${cleanUpHour(ntrl_eve2[0].f_time)}</span>
                  to <span style="font-weight:bold" id="ntrl_tt">${cleanUpHour(ntrl_eve2[0].t_time)}</span>
                  is pending. Click Book to proceed or click Cancel.`);
                // $('#ntrl_cd').append(datePipe.transform(new Date(ntrl_evnt[0].click_date), 'MM/dd/yyyy'));
                $('#neutral_event').modal('show');
              });
            }
          }
          const rm = this.storage.get('select_room');
          if (rm) {
            this.select_room = rm;
          }
        }
      } else {
        // console.log("error");
      }
    });
  }


  eventAdd() {
    this.f_time = document.getElementById('f_time').value;
    this.t_time = document.getElementById('t_time').value;
    const rumid = document.getElementById('rumid').value;
    if (rumid && rumid !== '') {
      this.room_id = rumid;
    }
    this.date_val = document.getElementById('click_date').value;
    const c_date = new Date(this.date_val);
    if (!this.room_id) {
      this.toasterService.pop('info', 'Info', 'please, select the room.');
    } else {
      if (this.f_time === this.t_time) {
        this.toasterService.pop('info', 'Info', 'Both time can not be same.');
      } else if (this.f_time > this.t_time) {
        this.toasterService.pop('info', 'Info', 'You have entered wrong Time.');
      } else {
        this.date_val = moment(this.date_val).format('YYYY-MM-DD'); // this.datePipe.transform(this.date_val, 'yyyy-MM-dd');
        // console.log(this.e_name);
        const time_from = this.date_val + ' ' + this.f_time + ':00';
        const time_to = this.date_val + ' ' + this.t_time + ':00';
        // console.log(time_from);
        // console.log(time_to);
        const diffInMs: number = Date.parse(time_to) - Date.parse(time_from);
        const diffInHours: number = diffInMs / 1000 / 60 / 60;
        this.hourDiff = diffInHours;
        this.busy = this.meetingService.addnewMeeting(this.authcode, this.room_id, time_from, time_to, this.e_name).subscribe(response => {
          if (response) {
            if (+response.success === -1) {
              this.logOut(response.message);
            } else {
              // console.log(response);
              if (response.success === 0) {
                if (response.missinghours) {
                  // console.log(response.missinghours);
                  this.missinghours = response.missinghours;

                  const room_id = document.getElementById('rumid').value;
                  const f_time = document.getElementById('f_time').value;
                  const t_time = document.getElementById('t_time').value;
                  const click_date = document.getElementById('click_date').value;
                  const room_name = $('#select_room b').text();
                  const e_name = this.e_name;
                  this.neutral_event2 = [{
                    'r_id': room_id,
                    'f_time': f_time,
                    't_time': t_time,
                    'e_name': e_name,
                    'click_date': click_date,
                    'room_name': room_name,
                    'city_id': this.city_id,
                    'building_id': this.building_id,
                    'address': this.select_building,
                    'past_avail_hour': this.avail_hours
                  }];
                  this.storage.set('neutral_event2', this.neutral_event2);
                  setTimeout(function () {
                    (<any>$('#myModal33')).modal('show');
                  }, 500);

                  $('#buyxxhour').show();
                  $('#buy5hour').show();
                  $('#buy15hour').show();
                  $('.never_expire').empty();
                  $('.never_expire').append('Please note unused additional hours never expire');
                  $('.not_enough_hour').empty();
                  $('.not_enough_hour')
                    .append('You require ' + this.hourDiff + ' hour and you only have ' + this.avail_hours + '. You can revise your reservation or purchase more hours using one of the buttons below.');
                  if (!this.select_room) {
                    this.room_id = null;
                  }
                  this.toasterService.pop('error', response.message);
                } else {
                  this.toasterService.pop('error', response.message);
                }
              } else {
                this.toasterService.pop('success', 'Success', 'Meeting added Successfully');
                if (this.select_room) {
                  this.getRoomsMeeting(this.room_id);
                } else {
                  // console.log('in building meeting');
                  this.room_id = null;
                  const building = this.storage.get('select_building_id');
                  this.getBuildingsMeeting(building, this.authcode);
                }
                this.getavailHours();
              }
            }
          } else {
            // console.log("error");
          }
        });
      }
    }
  }

  eventDelete() {
    const meeting_id = document.getElementById('delete_click').value;
    // console.log(meeting_id);
    this.busy = this.meetingService.eventDelete(meeting_id, this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          // console.log(response);
          if (response.success === 1) {
            // this.s_msg = "Your Meeting Deleted successfully."
            this.toasterService.pop('success', 'Success', 'Your Meeting Deleted successfully.');
            if (this.room_id) {
              this.getRoomsMeeting(this.room_id);
            } else if (this.building_id) {
              this.getBuildingsMeeting(this.building_id, this.authcode);
            } else {
              this.getAllMeetings();
            }
            this.getavailHours();
          } else {
            // this.msg = "Unable to Delete.";
            this.toasterService.pop('error', 'Oops!', 'Unable to Delete.');
          }
        }
      }
    });
  }

  eventUpdate() {
    this.f_time = document.getElementById('f_time').value;
    this.t_time = document.getElementById('t_time').value;
    this.e_name = document.getElementById('e_name').value;
    this.date_eve = document.getElementById('event_date').value;
    this.date_eve = moment(this.date_eve).format('YYYY-MM-DD'); // this.datePipe.transform(this.date_eve, 'yyyy-MM-dd');
    // console.log(this.e_name);
    const time_from = this.date_eve + ' ' + this.f_time + ':00';
    const time_to = this.date_eve + ' ' + this.t_time + ':00';
    // console.log(time_from);
    // console.log(time_to);
    const meeting_id = document.getElementById('delete_click').value;
    // console.log(meeting_id);
    this.busy = this.meetingService.eventEdit(meeting_id, this.authcode, time_from, time_to, this.e_name).subscribe(response => {
      if (response) {
        // console.log(response);
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          if (response.success === 1) {
            // this.s_msg = "Your Meeting Updated successfully."
            this.toasterService.pop('success', 'Success', 'Your Meeting Updated successfully.');
            if (this.room_id) {
              this.getRoomsMeeting(this.room_id);
            } else if (this.building_id) {
              this.getBuildingsMeetingbyside(this.building_id, this.authcode);
            }
            this.getavailHours();
          } else {
            // this.msg = "Unable to update.";
            this.toasterService.pop('error', 'Unable to update.');
          }
        }
      } else {
        // console.log("error");
      }
    });
  }

  getCity() {

    // // console.log(this.authcode);
    this.busy = this.meetingService.getCity(this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          this.city = response;
          // console.log(this.city);

          // pr's code
          if (this.storage.get('select_city') && this.storage.get('select_city_id')) {
            this.select_city = this.storage.get('select_city');
            const c_id = this.storage.get('select_city_id');
            this.city_id = c_id;
            this.getBuildings(c_id, this.select_city);
          } else {
            // console.log();
            const c_id = this.user[0].defaultcity;
            this.city_id = c_id;
            let city_name;
            for (let c = 0; c < this.city.length; c++) {
              if (this.city[c].id === c_id) {
                city_name = this.city[c].cityname;
              }
            }
            if (c_id !== 0) {
              this.getBuildings(c_id, city_name);
            } else {
              setTimeout(function () {
                (<any>$('#def_city')).modal('show');
              }, 500);
            }
          }
        }
        //
      }
    });
  }

  getBuildings(c_id, cityname) {
    $('#calendar').css('display', '');
    // pr's code
    this.city_id = c_id;
    if (c_id === this.storage.get('select_city_id') && this.storage.get('select_building')) {
      $('#calendar').fullCalendar('removeEvents');
      const populateOpenTimeIntervalArrayFunc = this.populateOpenTimeIntervalArray.bind(this);
      this.busy = this.meetingService.getBuildings(c_id, this.authcode).subscribe(response => {
        if (response) {
          if (+response.success === -1) {
            this.logOut(response.message);
          } else {
            populateOpenTimeIntervalArrayFunc(response[0].opentime.replace(/:\d+$/, ''), response[0].closetime.replace(/:\d+$/, ''));
            $('#calendar').fullCalendar('option', 'minTime', response[0].opentime.replace(/:\d+$/, ''));
            $('#calendar').fullCalendar('option', 'maxTime', response[0].closetime.replace(/:\d+$/, ''));
            this.buildings = response;
            this.select_building = this.storage.get('select_building');
            // console.log(this.select_building);
            this.building_id = this.storage.get('select_building_id');
            if (this.storage.get('select_room')) {
              // console.log("room is selected");
              // this.select_room = this.storage.get('select_room');
              // this.room_id = this.storage.get('select_room_id');
              // this.seats = this.storage.get('seats');
              // // console.log('room-'+this.select_room);
              this.getRooms(this.building_id, this.select_building);
            } else {
              // console.log("room is not selected");
              this.getRooms(this.building_id, this.select_building);
            }
          }
        }
      });
    } else {
      this.select_city = cityname;
      this.storage.set('select_city', this.select_city);
      this.storage.set('select_city_id', c_id);
      this.storage.remove('select_building');
      this.storage.remove('select_building_id');
      this.storage.remove('select_room');
      this.storage.remove('select_room_id');
      this.select_building = null;
      this.select_room = null;
      this.buildings = null;
      this.building_id = null;
      this.rooms = null;
      this.room_id = null;
      $('#calendar').fullCalendar('removeEvents');
      const view = $('#calendar').fullCalendar('getView');
      // console.log(view.name);
      if (view.name === 'Buildingweek' || view.name === 'agendaWeek') {
        $('#calendar').fullCalendar('changeView', 'agendaWeek');
      } else {
        $('#calendar').fullCalendar('changeView', 'agendaDay');
      }

      const populateOpenTimeIntervalArrayFunc = this.populateOpenTimeIntervalArray.bind(this);
      this.busy = this.meetingService.getBuildings(c_id, this.authcode).subscribe(response => {
        if (response) {
          if (+response.success === -1) {
            this.logOut(response.message);
          } else {
            populateOpenTimeIntervalArrayFunc(response[0].opentime.replace(/:\d+$/, ''), response[0].closetime.replace(/:\d+$/, ''));
            $('#calendar').fullCalendar('option', 'minTime', response[0].opentime.replace(/:\d+$/, ''));
            $('#calendar').fullCalendar('option', 'maxTime', response[0].closetime.replace(/:\d+$/, ''));
            this.buildings = response;
            // $("#calendar").fullCalendar('changeView', 'agendaWeek');
            if (this.buildings.length === 1) {
              this.getRooms(this.buildings[0].id, this.buildings[0].address);
            }
          }
          // // console.log(response);
        }
      });

    }

  }

  getBuildingsMeeting(b_id, authcode) {

    if (b_id) {
      this.building_id = b_id;
    } else {
      const bid = this.storage.get('select_building_id');
      this.building_id = bid;
    }
    this.currentDate = $('#calendar').fullCalendar('getDate');
    const view = $('#calendar').fullCalendar('getView');
    // // console.log(view.name);
    const dt = new Date(this.currentDate._d);
    // console.log(dt);
    const dayname = moment(dt).format('ddd'); // this.datePipe.transform(dt, 'EE');

    let stdt;
    let ldt;

    // var stdt = this.datePipe.transform(dt, 'yyyy-MM-dd');
    if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
      if (dayname === 'Mon') {
        const chk = dt.setDate(dt.getDate());
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Tue') {
        const chk = dt.setDate(dt.getDate() - 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Wed') {
        const chk = dt.setDate(dt.getDate() - 2);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Thu') {
        const chk = dt.setDate(dt.getDate() - 3);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Fri') {
        const chk = dt.setDate(dt.getDate() - 4);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sat') {
        const chk = dt.setDate(dt.getDate() - 5);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sun') {
        // console.log("hiii");
        const chk = dt.setDate(dt.getDate() + 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 5);
      }

    } else {
      stdt = moment(dt).format('YYYY-MM-DD'); // this.datePipe.transform(dt, 'yyyy-MM-dd');
      ldt = dt.setDate(dt.getDate() + 1);
    }
    const ldtd = new Date(ldt);
    const ltdt = moment(ldtd).format('YYYY-MM-DD'); // this.datePipe.transform(ldtd, 'yyyy-MM-dd');

    this.meetingService.getBuildingsMeeting(this.building_id, authcode, stdt, ltdt).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {

          $('#calendar').fullCalendar('refetchEvents');
          $('#calendar').fullCalendar('removeEvents');

          if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
            // console.log("if view");
            $('#calendar').fullCalendar('changeView', 'Buildingweek');
          } else {
            $('#calendar').fullCalendar('changeView', 'Buildingday');
          }

          for (let i = 0; i < this.rooms.length; i++) {
            $('th[data-resource-id=' + this.rooms[i].id + ']')
              .html('<b>' + this.rooms[i].caldesc + '</b><p style=\'font-weight:100\'>' + this.rooms[i].line2 + '</p>');
          }

          for (let i = 0; i < response.length; i++) {
            // if(response[i].userid == this.user[0].userid){

            let editable;
            let color;

            if (+response[i].editable === 0) {
              editable = false;
              color = '#3a87ad';
            } else {
              editable = true;
              color = '#8dc009';
            }


            const event = {
              id: response[i].meetingid,
              resourceId: response[i].roomid,
              title: response[i].description,
              start: response[i].start,
              end: response[i].end,
              editable: editable,
              color: color,
              avail_hours: this.avail_hours
            };
            $('#calendar').fullCalendar('renderEvent', event, true);
            // this.getavailHours();
            // }
          }
        }
      } else {
        // console.log("error");
      }
    });
  }

  getRooms(b_id, b_name) {
    // this.select_room = null;

    // pr's code
    if (b_id === this.storage.get('select_building_id') && this.storage.get('select_room')) {
      $('#calendar').fullCalendar('removeEvents');
      this.meetingService.getRooms(b_id, this.authcode).subscribe(response => {
        if (response) {
          if (+response.success === -1) {
            this.logOut(response.message);
          } else {
            this.rooms = response;
            const resources = $('#calendar').fullCalendar('getResources');
            // // console.log(resources);
            for (let i = 0; i < resources.length; i++) {
              $('#calendar').fullCalendar('removeResource', {
                id: resources[i].id
              });
            }
            // $("#calendar").fullCalendar('changeView','Buildingweek');
            for (let i = 0; i < response.length; i++) {
              $('#calendar').fullCalendar('addResource', {
                id: response[i].id, title: response[i].caldesc, temp_name: response[i].roomname
              });
            }
            for (let i = 0; i < response.length; i++) {
              $('th[data-resource-id=' + response[i].id + ']')
                .html('<b>' + response[i].caldesc + '</b><p style=\'font-weight:100\'>' + response[i].line2 + '</p>');
            }
            // this.resource
            this.select_room = this.storage.get('select_room');
            // // console.log(this.select_room);
            this.room_id = this.storage.get('select_room_id');
            this.seats = this.storage.get('seats');
            if (this.storage.get('select_room')) {
              // this.select_room = this.storage.get('select_room');
              // this.room_id = this.storage.get('select_room_id');
              // this.seats = this.storage.get('seats');
              // // console.log('room-'+this.select_room);
              this.getRoomsMeeting(this.room_id);
            } else {
              this.getBuildingsMeeting(b_id, this.authcode);
            }
          }
        } else {
          // console.log("error");
        }
      });
    } else {
      this.select_building = b_name;
      this.storage.set('select_building', this.select_building);
      this.storage.set('select_building_id', b_id);
      this.storage.remove('select_room');
      this.storage.remove('select_room_id');
      this.select_room = null;
      this.rooms = null;
      this.room_id = null;
      $('#calendar').fullCalendar('removeEvents');

      this.busy = this.meetingService.getRooms(b_id, this.authcode).subscribe(response => {
        if (response) {
          if (+response.success === -1) {
            this.logOut(response.message);
          } else {
            this.rooms = response;
            const resources = $('#calendar').fullCalendar('getResources');
            // // console.log(resources);
            for (let i = 0; i < resources.length; i++) {
              $('#calendar').fullCalendar('removeResource', {
                id: resources[i].id
              });
            }
            // $("#calendar").fullCalendar('changeView','Buildingweek');
            for (let i = 0; i < response.length; i++) {
              $('#calendar').fullCalendar('addResource', {
                id: response[i].id, title: response[i].caldesc, temp_name: response[i].roomname
              });

            }
            for (let i = 0; i < response.length; i++) {
              $('th[data-resource-id=' + response[i].id + ']')
                .html('<b>' + response[i].caldesc + '</b><p style=\'font-weight:100\'>' + response[i].line2 + '</p>');
            }

            this.getBuildingsMeeting(b_id, this.authcode);
            // $("#calendar").fullCalendar('changeView', 'agendaWeek');
            // if(this.buildings.length == 1){
            //   this.getRooms(this.buildings[0].id, this.buildings[0].address);
            // }
            // // console.log(response);
          }
        } else {
          // console.log("error");
        }
      });

    }
  }

  roomSelected(r_id, r_name, seats) {
    this.select_room = r_name;
    this.storage.set('select_room', r_name);
    this.storage.set('select_room_id', r_id);
    this.room_id = r_id;
    this.seats = seats;
    this.storage.set('seats', seats);
    const view = $('#calendar').fullCalendar('getView');
    if (view.name === 'agendaDay' || view.name === 'Buildingday') {
      $('#calendar').fullCalendar('changeView', 'agendaDay');
    } else {
      $('#calendar').fullCalendar('changeView', 'agendaWeek');
    }
    this.getRoomsMeeting(r_id);
  }

  getRoomsMeeting(r_id) {
    if (this.storage.get('profile_meeting')) {
      // console.log(this.storage.get('profile_meeting'));
      $('#calendar').fullCalendar('changeView', 'agendaDay');
      const m_e_date = this.storage.get('profile_event_date');
      $('#calendar').fullCalendar('gotoDate', m_e_date);
      this.storage.remove('profile_meeting');
      this.storage.remove('profile_event_date');
    }

    this.currentDate = $('#calendar').fullCalendar('getDate');
    const view = $('#calendar').fullCalendar('getView');
    // console.log(view.name);
    if (view.name === 'Buildingweek') {
      if (this.select_room) {
        $('#calendar').fullCalendar('changeView', 'agendaWeek');
      } else {
        $('#calendar').fullCalendar('changeView', 'Buildingweek');
      }
    } else if (view.name === 'agendaDay') {
      $('#calendar').fullCalendar('changeView', 'agendaDay');
    }
    const dt = new Date(this.currentDate._d);
    const dayname = moment(dt).format('ddd'); // this.datePipe.transform(dt, 'EE');

    let stdt;
    let ldt;

    // console.log(dt);
    if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
      if (dayname === 'Mon') {
        const chk = dt.setDate(dt.getDate());
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Tue') {
        const chk = dt.setDate(dt.getDate() - 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Wed') {
        const chk = dt.setDate(dt.getDate() - 2);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Thu') {
        const chk = dt.setDate(dt.getDate() - 3);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Fri') {
        const chk = dt.setDate(dt.getDate() - 4);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sat') {
        const chk = dt.setDate(dt.getDate() - 5);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sun') {
        // console.log("hiii");
        const chk = dt.setDate(dt.getDate() + 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 5);
      }

    } else {
      stdt = moment(dt).format('YYYY-MM-DD'); // this.datePipe.transform(dt, 'yyyy-MM-dd');
      ldt = dt.setDate(dt.getDate() + 1);
    }
    const ldtd = new Date(ldt);
    const ltdt = moment(ldtd).format('YYYY-MM-DD'); // this.datePipe.transform(ldtd, 'yyyy-MM-dd');
    // // console.log("rooms meeting");
    this.busy = this.meetingService.getRoomsMeeting(r_id, this.authcode, stdt, ltdt).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          const resources = $('#calendar').fullCalendar('getResources');
          // // console.log(resources);
          // for(var i=0; i<resources.length; i++){
          //   $('#calendar').fullCalendar('removeResource', {
          //       id: resources[i].id
          //   });
          // }
          $('#calendar').fullCalendar('refetchEvents');
          $('#calendar').fullCalendar('removeEvents');
          for (let i = 0; i < response.length; i++) {
            // if(response[i].userid == this.user[0].userid){

            let editable;
            let color;

            if (+response[i].editable === 0) {
              editable = false;
              color = '#3a87ad';
            } else {
              editable = true;
              color = '#8dc009';
            }
            const event = {
              id: response[i].meetingid,
              resourceId: response[i].roomid,
              title: response[i].description,
              start: response[i].start,
              end: response[i].end,
              editable: editable,
              color: color,
              avail_hours: this.avail_hours
            };
            $('#calendar').fullCalendar('renderEvent', event, true);
            // }
          }
          // this.getavailHours();
        }
      }
    });
  }

  addHours(id) {
    // // console.log(id);
    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          if (response === '') {
            if (this.city_id) {
              window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=' + this.city_id, '_blank');
            } else {
              window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&city=0', '_blank');
            }
            // console.log("no saved card found");
          } else {
            this.storage.set('open_from_addhours', 'yes');
            setTimeout(function () {
              (<any>$('#myModal')).modal('show');
            }, 500);

          }
        }
      }
    });


  }

  addhoursqry(id) {
    // // console.log(id);
    // this.eventremember();
    const hour = document.getElementById('miss_hour').value;
    // // console.log(hour);

    let cid;

    if (this.city_id) {
      cid = this.city_id;
    } else {
      cid = '0';
    }
    if (hour === 5) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price2=1&city=' + cid, '_blank');
    } else if (hour === 15) {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price3=1&city=' + cid, '_blank');
    } else {
      window.open('https://www.opusmeetingrooms.com/omrcc/?juid=' + id + '&price1=' + hour + '&city=' + cid, '_blank');
    }

  }

  refetchEvent() {
    if (this.room_id) {
      this.fetchRoommeeting(this.room_id);
    } else if (this.building_id) {
      this.getBuildingsMeeting(this.building_id, this.authcode);
    }
  }

  jump() {
    if (this.skipdate) {
      if (this.skipdate.toString().length > 9) {
        let year = this.skipdate.substring(0, 4);
        if (parseInt(year) > 2010) {
          if (this.select_city) {
            $('#calendar').fullCalendar('changeView', 'agendaDay');
            $('#calendar').fullCalendar('gotoDate', this.skipdate);
            this.skipdate = '';
            if (this.room_id) {
              this.getRoomsMeeting(this.room_id);
            } else if (this.building_id) {
              this.getBuildingsMeeting(this.building_id, this.authcode);
            } else {
              this.getAllMeetings();
            }
          } else {
            this.toasterService.pop('error', 'Please select building first');
          }
        }
      }
    }
  }

  profileShow() {
    // // console.log("profile");

    const link = ['/profile'];
    this.router.navigate(link);
    // window.location.reload();
  }

  AllRoom() {
    this.storage.remove('select_room_id');
    this.storage.remove('select_room');
    // this.getRooms(this.room_id, this.storage.get('select_building'));
    this.storage.remove('seats');
    this.select_room = 'All Rooms';
    this.room_id = null;
    const bid = this.storage.get('select_building_id');
    // $("#calendar").fullCalendar('changeView','Buildingweek');
    this.getBuildingsMeeting(bid, this.authcode);
  }

  defineMissinhour(hour) {
    // // console.log(hour);
    $('#miss_hour').val(hour);
    setTimeout(function () {
      (<any>$('#myModal')).modal('show');
    }, 500);
  }

  getSavedCard() {
    // this.eventremember();
    if (this.storage.get('open_from_addhours') && this.storage.get('open_from_addhours') === 'yes') {
      // $('#saved_card').modal('hide');
      // var cardid = card.cardid;
      // var cvv = document.getElementById('cvv_'+cardid).value;
      // this.storage.set('cardid',cardid);
      // this.storage.set('cvvnum',cvv);
      const link = ['/makepayment'];
      this.router.navigate(link);
    }

    this.meetingService.GetSavedCards(this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          if (response === '') {
            // console.log("no saved card found");
          } else {
            // console.log(response);
            this.saved_cards = response;
            setTimeout(function () {
              $('#update_add').hide();
              (<any>$('#saved_card')).modal('show');
            }, 500);
          }
        }
      } else {
        // console.log("error");
      }
    });
  }

  // eventremember(){
  //
  //   return;
  // }

  makePayment(card) {
    if (this.storage.get('open_from_addhours') && this.storage.get('open_from_addhours') === 'yes') {
      $('#saved_card').modal('hide');
      const cardid = card.cardid;
      const cvv = document.getElementById('cvv_' + cardid).value;
      this.storage.set('cardid', cardid);
      this.storage.set('cvvnum', cvv);
      const link = ['/makepayment'];
      this.router.navigate(link);
    } else {
      const cardid = card.cardid;
      const cvv = document.getElementById('cvv_' + cardid).value;
      // // console.log(cvv);
      // // console.log(cardid);
      const hour = document.getElementById('miss_hour').value;
      // // console.log(hour);

      let amount;

      if (hour < 5) {
        amount = hour * 25;
      } else if (hour === 5) {
        amount = 100.00;
      } else if (hour === 15) {
        amount = 225.00;
      }
      // console.log(amount);
      this.busy = this.meetingService.useSavedCard(this.authcode, this.user[0].userid, amount, cardid, cvv, hour).subscribe(response => {
        if (response) {
          if (+response.success === -1) {
            this.logOut(response.message);
          } else {
            if (response.success === 1) {
              this.cs_msg = response.message;
              this.getavailHours();
              window.scrollTo(0, 0);
            } else {

              $('#update_add').show();
              this.payment_fail = response.message;
              window.scrollTo(0, 0);
              this.interval = setTimeout(() => {
                this.payment_fail = '';
              }, 4000);
            }
          }
        } else {
          // console.log("error");
        }
      });
    }
  }

  neutralEventAdd() {
    this.storage.remove('neutral_event2');
    this.f_time = document.getElementById('f_time2').value;
    this.t_time = document.getElementById('t_time2').value;
    const rumid = document.getElementById('rumid2').value;
    if (rumid && rumid !== '') {
      this.room_id = rumid;
    }
    this.date_val = document.getElementById('click_date2').value;
    const c_date = new Date(this.date_val);
    if (!this.room_id) {
      this.toasterService.pop('info', 'Info', 'please, select the room.');
    } else {
      if (this.f_time === this.t_time) {
        this.toasterService.pop('info', 'Info', 'Both time can not be same.');
      } else if (this.f_time > this.t_time) {
        this.toasterService.pop('info', 'Info', 'You have entered wrong Time.');
      } else {
        this.date_val = moment(this.date_val).format('YYYY-MM-DD'); // this.datePipe.transform(this.date_val, 'yyyy-MM-dd');
        // console.log(this.e_name);
        const time_from = this.date_val + ' ' + this.f_time + ':00';
        const time_to = this.date_val + ' ' + this.t_time + ':00';
        // console.log(time_from);
        // console.log(time_to);
        const diffInMs: number = Date.parse(time_to) - Date.parse(time_from);
        const diffInHours: number = diffInMs / 1000 / 60 / 60;
        this.hourDiff = diffInHours;
        this.busy = this.meetingService.addnewMeeting(this.authcode, this.room_id, time_from, time_to, this.e_name).subscribe(response => {
          if (response) {
            if (+response.success === -1) {
              this.logOut(response.message);
            } else {
              // console.log(response);
              if (response.success === 0) {
                if (response.missinghours) {
                  // console.log(response.missinghours);
                  this.missinghours = response.missinghours;
                  setTimeout(function () {
                    (<any>$('#myModal33')).modal('show');
                  }, 500);
                  const rmnm = $('#select_room1 b').html();
                  // console.log(rmnm);
                  $('#select_room b').empty();
                  $('#select_room b').append(rmnm);
                  $('#buyxxhour').show();
                  $('#buy5hour').show();
                  $('#buy15hour').show();
                  $('#updatebtn').hide();
                  $('#delbtn').hide();
                  $('.never_expire').empty();
                  $('.never_expire').append('Please note unused additional hours never expire');
                  $('.not_enough_hour').empty();
                  $('.not_enough_hour').append(`
              You require ${this.hourDiff} hour and you only have ${this.avail_hours}.
              You can revise your reservation or purchase more hours using one of the buttons below.`);
                  if (!this.select_room) {
                    this.room_id = null;
                  }
                  this.toasterService.pop('error', response.message);
                } else {
                  this.toasterService.pop('error', response.message);
                }
              } else {
                this.toasterService.pop('success', 'Success', 'Meeting added Successfully');
                const ntrlcity_id = document.getElementById('ntrlcity_id').value;
                const ntrl_address = document.getElementById('ntrl_address').value;
                const ntrl_building_id = document.getElementById('ntrl_building_id').value;
                // console.log(ntrl_address);
                // console.log(this.city);
                for (let n = 0; n < this.city.length; n++) {
                  if (this.city[n].id === ntrlcity_id) {
                    const ntrlcity_name = this.city[n].cityname;
                    this.storage.set('select_city', ntrlcity_name);
                  }
                }
                this.storage.set('select_building_id', ntrl_building_id);
                this.storage.set('select_building', ntrl_address);
                this.storage.set('select_city_id', ntrlcity_id);
                this.getCity();
              }
            }
          }
        });
      }
    }
  }

  cancelNeutralEvent() {
    this.storage.remove('neutral_event');
    this.storage.remove('neutral_event2');
  }

  openSavedCard() {
    const link = ['/savedcard'];
    this.router.navigate(link);
  }

  setDef_city() {
    this.busy = this.meetingService.getUserdata(this.authcode).subscribe(response => {
      if (response) {
        if (+response.success === -1) {
          this.logOut(response.message);
        } else {
          // console.log(response);
          const fname = response[0].firstname;
          const lname = response[0].lastname;
          const cname = response[0].companyname;
          const email = response[0].email;
          const phone = response[0].phone;
          const dcity = response[0].defaultcity;
          // this.getCity();
          this.busy = this.meetingService.updateUser(this.authcode, fname, lname, cname, email, phone, this.def_city).subscribe(res => {
            if (res) {
              if (res.success === '-1') {
                this.logOut(res.message);
              } else {
                // console.log(response);
                if (res.success === 1) {
                  $('#def_city').modal('hide');
                  this.user[0].defaultcity = this.def_city;
                  this.storage.set('user', this.user);
                  this.getCity();
                  this.defaultCityModalCloseable = true;
                } else {
                  this.err_msg = res.message;
                  window.scrollTo(0, 0);
                }
              }
            }
          });
          // console.log(fname);
        }
      }
    });


  }

  signOut() {
    this.busy = this.meetingService.logout(this.authcode).subscribe(response => {
      if (response) {
        if (response[0].success === 1) {
          // // console.log(response);
          this.storage.remove('user');
          this.storage.remove('select_city');
          this.storage.remove('select_city_id');
          this.storage.remove('select_building');
          this.storage.remove('select_building_id');
          this.storage.remove('select_room');
          this.storage.remove('select_room_id');
          this.storage.remove('seats');
          this.authcode = null;
          this.user = null;
          this.room_id = null;
          this.building_id = null;
          this._cookieService.put('msg', response[0].message);
          const link = ['/login'];
          this.router.navigate(link);
          // this.delete_cookie('user');
          // window.location.href = "http://ovo.dev.bluelightit.com/?message=Logout%20Successful";
        } else {
          this.toasterService.pop('error', response[0].message);
        }
      }
    }, (err) => {
      this.signOut();
    });

  }

  logOut(message) {

    this.storage.remove('user');
    this.storage.remove('select_city');
    this.storage.remove('select_city_id');
    this.storage.remove('select_building');
    this.storage.remove('select_building_id');
    this.storage.remove('select_room');
    this.storage.remove('select_room_id');
    this.storage.remove('seats');
    this.authcode = null;
    this.user = null;
    this.room_id = null;
    this.building_id = null;
    this._cookieService.put('msg', message);
    const link = ['/login'];
    this.router.navigate(link);

  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

}
